import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
// import { getUserByToken } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  setLoading: "[Set listLoading] Action",
  setActionLoading: "[Set actionLoading] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  listLoading: false,
  actionLoading: false,
};

export const reducer = persistReducer(
  { storage, key: "atacante-auth", whitelist: ["user", "authToken", "listLoading", "actionLoading"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { ...state, authToken };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { ...state, authToken };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user, listLoading: false, actionLoading: false };
      }

      case actionTypes.setLoading: {
        const { listLoading } = action.payload;
        return { ...state, listLoading };
      }

      case actionTypes.setActionLoading: {
        const { actionLoading } = action.payload;
        return { ...state, actionLoading };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  setLoading: (listLoading) => ({ type: actionTypes.setLoading, payload: { listLoading } }),
  setActionLoading: (actionLoading) => ({ type: actionTypes.setActionLoading, payload: { actionLoading } }),
};

export function* saga() {
  // yield takeLatest(actionTypes.Login, function* loginSaga() {
  //   yield put(actions.requestUser());
  // });

  // yield takeLatest(actionTypes.Register, function* registerSaga() {
  //   yield put(actions.requestUser());
  // });

  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //   const { data: user } = yield getUserByToken();

  //   yield put(actions.fulfillUser(user));
  // });
}
